import './index.scss';
import './global.scss'; 
import './navigation.scss'; 
import './components.scss'; 
import './pages/all.ts'; 
import './pages/download.ts';
import './pages/cart.ts';
import './collection.scss'; 
import './cart.scss'; 
import './pages/product.ts';
import './modules/shopify-cart.client.ts';

const BSN = require("bootstrap.native/dist/bootstrap-native.esm.min.js");
(window as any).BSN = BSN; 
 
export default (async () => {
  console.log("Loaded 💖");

  document.addEventListener("DOMContentLoaded", async (event) => {
    const discTransferBuilderContainer = document.querySelector("#image-builder");
    if (discTransferBuilderContainer) {
      return await import(/* webpackChunkName: "image-builder" */ "./controllers/image-builder.ts");      
    }
  });
})();
 